export default "__VITE_ASSET__CtxOBFvt__"